function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  fill: "#FFF",
  d: "M16,33l-5,0c-1.011,-0.016 -1.312,-0.62 -0.949,-1.258l5.836,-10.387c0.187,-0.187 0.187,-0.374 0,-0.571l-3.455,-6.327c-0.601,-1.174 -0.381,-1.457 0.203,-1.457l5.365,0c0.602,0.021 0.733,0.423 1,1l4,6.981c0.187,0.187 0.187,0.374 0,0.57l-6,10.449c-0.208,0.516 -0.577,0.972 -1,1Zm23.65,-24l-10.736,19c-0.187,0.196 -0.187,0.383 0,0.58l7.086,12.42c0.373,0.74 -0.43,1 -1,1l-5,0c-0.385,-0.013 -0.617,-0.269 -1,-1l-6.984,-12.42c-0.197,-0.197 -0.197,-0.384 0,-0.58l10.984,-19c0.25,-0.776 0.804,-1 1,-1l5,0c0.383,0 0.846,0.617 0.65,1Z"
});

var SvgIcons8Xing = function SvgIcons8Xing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "8 7 35 38",
    width: "32px",
    height: "32px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8Xing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-xing.52d7c3c4.svg";
export { ForwardRef as ReactComponent };